import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import SliderSidebarLayout from "ui-kit/SliderSidebar/View";
import {
  actions as sliderSidebarActions,
  getters as sliderSidebarGetters
} from "ui-kit/SliderSidebar/model";
import {
  MOCK_QUICK_LINKS,
  MOCK_WIKI_PAGES,
  RESOURCES_FLYOVER_TABS_INSTANCE_ID,
  SIDEBAR_INSTANCE_ID
} from "../constants";
import { getters } from "../model";
import Tabs from "ui-kit/Tabs/View";
import { Div, Text4, MediumOutlineButton } from "components/Base";
import WikiPageThumbnail from "./WikiPageThumbnail";
import QuickLinkThumbnail from "./QuickLinkThumbnail";
import SearchBar from "ui-kit/SearchBar/View";
import { getters as TabGetters } from "ui-kit/Tabs";
import { noop } from "utils/General";
import { actions as portalHomeActions } from "Portal/NewPortal/PortalHome/model";

import { getters as wrapperGetters } from "Portal/NewPortal/Wrapper/model";

const GAPPED_CONTAINER_STYLES = { gap: "16px" };

const ICON_STYLES = { fontSize: "20px", color: "#494949", cursor: "pointer" };

const FileDetailSidebar = ({
  activeTab = "wiki",
  wikiPages = MOCK_WIKI_PAGES,
  quickLinks = MOCK_QUICK_LINKS,
  searchTerm = "",
  setActiveWikiPage = noop,
  hideModal = noop,
  flyOverWidth = null
}) => {
  const upperSearchTerm = searchTerm.toUpperCase();
  return (
    <SliderSidebarLayout
      position="right"
      instanceId={SIDEBAR_INSTANCE_ID}
      style={{
        borderRadius: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}
      width={flyOverWidth}
    >
      <Div width={1} height={1} display="column.space-between.flex-start">
        <Div display="column.flex-start.flex-start" width={1}>
          <Div
            width={1}
            display="row.space-between.center"
            bb={1}
            bc="#E7E6EA"
            px={5}
            py={4}
          >
            <Div display="row.flex-start.center">
              <i className="material-icons-outlined" style={ICON_STYLES}>
                pages
              </i>
              <Text4 style={{ fontSize: "20px" }} bold ml={1.5} color="#494949">
                {" "}
                Resources
              </Text4>
            </Div>
            <i
              className="material-icons"
              onClick={hideModal}
              style={ICON_STYLES}
            >
              close
            </i>
          </Div>
          <Div
            width={1}
            px={5}
            py={4}
            style={{ height: "calc(100dvh - 125px)", overflowY: "auto" }}
          >
            <Div
              mb={4}
              width={1}
              bb={1}
              bc="#E7E6EA"
              display="row.flex-start.flex-start"
            >
              <Tabs
                instanceId={RESOURCES_FLYOVER_TABS_INSTANCE_ID}
                tabs={[
                  {
                    title: `Wiki Pages (${wikiPages.length})`,
                    id: "wiki"
                  },
                  {
                    title: `Quick Links (${quickLinks.length})`,
                    id: "quick"
                  }
                ]}
                iniSelected={activeTab}
                tabStyle={{
                  fs: 3,
                  pb: 3,
                  flex: 1
                }}
              />
            </Div>
            <Div width={1} mb={4}>
              <SearchBar placeholder="Search" searchTerm={searchTerm} />
            </Div>
            <Div width={1}>
              {activeTab === "wiki" ? (
                <Div
                  display="column.flex-start.center"
                  style={GAPPED_CONTAINER_STYLES}
                  width={1}
                >
                  {wikiPages
                    .filter(
                      ({ title, text }) =>
                        title.toUpperCase().includes(upperSearchTerm) ||
                        text.toUpperCase().includes(upperSearchTerm)
                    )
                    .map(({ id, image, title, text }, index) => (
                      <WikiPageThumbnail
                        id={id}
                        setActiveWikiPage={setActiveWikiPage}
                        key={`wiki-thumbnail-${index}`}
                        image={image}
                        text={text}
                        title={title}
                      />
                    ))}
                </Div>
              ) : (
                <Div
                  display="column.space-between.center"
                  style={GAPPED_CONTAINER_STYLES}
                  width={1}
                >
                  {quickLinks
                    .filter(
                      ({ url, text }) =>
                        url.toUpperCase().includes(upperSearchTerm) ||
                        text.toUpperCase().includes(upperSearchTerm)
                    )
                    .map(({ url, color, icon, text }, index) => (
                      <QuickLinkThumbnail
                        key={`quick-thumbnail-${index}`}
                        url={url}
                        color={color}
                        icon={icon}
                        text={text}
                      />
                    ))}
                </Div>
              )}
            </Div>
          </Div>
        </Div>
        <Div
          width={1}
          display="row.flex-start.flex-start"
          px={5}
          py={4}
          bt={1}
          bc="#E7E6EA"
        >
          <MediumOutlineButton onClick={hideModal}>Cancel</MediumOutlineButton>
        </Div>
      </Div>
    </SliderSidebarLayout>
  );
};

const decorate = R.compose(
  connect(
    (state, props) => ({
      isDrawerOpen: sliderSidebarGetters.isDrawerOpen(state, {
        ...props,
        instanceId: SIDEBAR_INSTANCE_ID
      }),
      loading: getters.loading(state),
      wikiPages: getters.wikiPages(state),
      quickLinks: getters.quickLinks(state),
      searchTerm: getters.searchTerm(state),
      activeTab: TabGetters.selectedTab(state, {
        instanceId: RESOURCES_FLYOVER_TABS_INSTANCE_ID
      }),
      flyOverWidth: wrapperGetters.flyOverWidth(state)
    }),
    {
      hideModal: () =>
        sliderSidebarActions.setIsDrawerOpen(false, {
          meta: { instanceId: SIDEBAR_INSTANCE_ID }
        }),
      setActiveWikiPage: portalHomeActions.setActiveWikiPage
    }
  )
);

export default decorate(FileDetailSidebar);
